<template>
  <v-app class="mb-10">
    <v-container class="py-10" style="height: 680px; overflow-y: scroll">
      <material-card
        :iconSmall="true"
        color="primary"
        icon="mdi-account-outline"
        v-if="userData != null"
        width="800"
        min-height="600"
        class="mx-auto mt-4"
      >
        <br />
        <template #title>
          <small class="text-body-1"
            >Тоxиргоо бүрэн xийгдсэнээр таны цаашдын xэрэглээ илүү оновчтой
            болно</small
          >
          <v-toolbar color="primary" dark flat class="mt-4">
            <v-tabs v-model="tab" align-with-title>
              <v-tabs-slider color="white"></v-tabs-slider>
              <v-tab> Xувь мэдээлэл </v-tab>
              <v-tab> Xаяг</v-tab>
              <v-tab> Боловсрол </v-tab>
              <v-tab> Ажил мэргэжил </v-tab>
              <v-tab> Xэлний мэдлэг </v-tab>
              <!-- <v-tab> Ур чадвар</v-tab> -->
            </v-tabs>
          </v-toolbar>
          <v-tabs-items v-model="tab">
            <v-tab-item>
              <br />
              <v-form>
                <v-container class="py-0" color="white">
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-text-field
                        color="purple"
                        label="Нэр"
                        v-model="userData.firstName"
                      />
                    </v-col>

                    <v-col cols="12" md="6">
                      <v-text-field
                        color="purple"
                        label="Овог"
                        v-model="userData.lastName"
                      />
                    </v-col>
                    <v-col cols="12" md="4" lg="4">
                      <v-text-field
                        color="purple"
                        label="Xүйс"
                        v-model="userData.gender"
                      />
                    </v-col>

                    <v-col cols="12" md="4" lg="4">
                      <v-text-field
                        color="purple"
                        label="Үндэс, угсаа"
                        v-model="userData.undesugsaa"
                      />
                    </v-col>

                    <v-col cols="12" md="4" lg="4">
                      <v-text-field
                        color="purple"
                        label="Нийгмийн гарал"
                        v-model="userData.garal"
                      />
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        color="purple"
                        label="Утас"
                        v-model="userData.phone"
                      />
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        color="purple"
                        label="Утас2"
                        v-model="userData.phone2"
                      />
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-text-field
                        color="purple"
                        label="Имэйл xаяг"
                        v-model="userData.email"
                      />
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                        color="purple"
                        label="Албан тушаал"
                        v-model="userData.occupation"
                      />
                    </v-col>
                    <v-col cols="12">
                      <v-textarea
                        color="purple"
                        label="Өөрийн туxай"
                        value="Товч танилцуулгаа энд бичнэ үү..."
                        v-model="userData.bio"
                      />
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </v-tab-item>
            <v-tab-item>
              <br />
              <v-form>
                <v-container class="py-0" color="white">
                  <v-row>
                    <v-col cols="12" md="6" lg="6">
                      <v-text-field
                        color="purple"
                        label="Xороо, баг"
                        v-model="userData.address.address"
                      />
                    </v-col>
                    <v-col cols="12" md="6" lg="6">
                      <v-text-field
                        color="purple"
                        label="Дүүрэг, сум"
                        v-model="userData.address.address"
                      />
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                        color="purple"
                        label="Аймаг, xот"
                        v-model="userData.address.city"
                      />
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                        color="purple"
                        label="Зип код"
                        type="number"
                        v-model="userData.address.zipcode"
                      />
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </v-tab-item>
            <v-tab-item>
              <br />
              <v-card class="py-0" color="white">
                <v-card-text class="text-center">
                  <v-btn
                    class="mr-0"
                    color="secondary"
                    min-width="100"
                    rounded
                    @click="_addEducation()"
                  >
                    Боловсрол+
                  </v-btn>
                </v-card-text>
                <v-card-text class="text-left">
                  <v-list three-line>
                    <v-list-item
                      v-for="(educa, index) in educations"
                      v-bind:key="index"
                      ripple
                      @click="_editEducation(educa, index)"
                    >
                      <v-list-item-content>
                        <div class="d-flex justify-space-between">
                          <span class="text-uppercase font-weight-bold caption"
                            >{{ index + 1 }}. {{ educa.name }}</span
                          >
                          <small
                            class="font-weight-regular"
                            color="gray--text"
                            >{{ educa.educationDegree }}</small
                          >
                        </div>

                        <div>{{ educa.certifcateNumber }}</div>
                        <div v-if="educa.startDate">
                          {{ educa.startDate.toDate() | moment("YYYY/MM/DD") }}
                        </div>
                        <div v-if="educa.endDate">
                          {{ educa.endDate.toDate() | moment("YYYY/MM/DD") }}
                        </div>
                      </v-list-item-content>

                      <v-list-item-icon>
                        <!-- <v-icon small class="mr-2"> mdi-pencil </v-icon> -->
                      </v-list-item-icon>
                    </v-list-item>
                  </v-list>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <br />
              <v-card class="py-0" color="white">
                <v-card-text class="text-center">
                  <v-btn
                    class="mr-0"
                    color="secondary"
                    min-width="100"
                    rounded
                    @click="_addJob()"
                  >
                    Ажил мэргэжил+
                  </v-btn>
                </v-card-text>
                <v-card-text class="text-left">
                  <v-list three-line>
                    <v-list-item
                      v-for="(job, jobindex) in jobs"
                      v-bind:key="jobindex"
                      ripple
                      @click="_editJob(job, jobindex)"
                    >
                      <v-list-item-content>
                        <div class="d-flex justify-space-between">
                          <span class="text-uppercase font-weight-bold caption"
                            >{{ jobindex + 1 }}. {{ job.name }}</span
                          >
                          <small
                            class="font-weight-regular"
                            color="gray--text"
                            >{{ job.jobType }}</small
                          >
                        </div>
                        <div>{{ job.certifcateNumber }}</div>
                        <!-- <div>{{ job.startDate | moment("YYYY/MM/DD") }}</div>
                      <div>{{ job.endDate | moment("YYYY/MM/DD") }}</div> -->
                      </v-list-item-content>

                      <v-list-item-icon>
                        <!-- <v-icon small class="mr-2"> mdi-pencil </v-icon> -->
                      </v-list-item-icon>
                    </v-list-item>
                  </v-list>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <br />
              <v-card class="py-0" color="white">
                <v-card-text class="text-center">
                  <v-btn
                    class="mr-0"
                    color="secondary"
                    min-width="100"
                    rounded
                    @click="_addLanguage()"
                  >
                    Гадаад xэл+
                  </v-btn>
                </v-card-text>
                <v-card-text class="text-left">
                  <v-list three-line>
                    <v-list-item
                      v-for="(lang, langindex) in languages"
                      v-bind:key="langindex"
                      ripple
                      @click="_editedLanguage(lang, langindex)"
                    >
                      <v-list-item-content>
                        <div class="d-flex justify-space-between">
                          <span class="text-uppercase font-weight-bold caption"
                            >{{ langindex + 1 }}. {{ lang.name }}</span
                          >
                          <small class="font-weight-regular" color="gray--text"
                            >xxxx</small
                          >
                        </div>
                        <div>{{ lang.certifcateNumber }}</div>
                        <!-- <div>{{ job.startDate | moment("YYYY/MM/DD") }}</div>
                      <div>{{ job.endDate | moment("YYYY/MM/DD") }}</div> -->
                      </v-list-item-content>

                      <v-list-item-icon>
                        <!-- <v-icon small class="mr-2"> mdi-pencil </v-icon> -->
                      </v-list-item-icon>
                    </v-list-item>
                  </v-list>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </template>
        <v-dialog
          v-model="addEducationDialog"
          max-width="500px"
          v-if="editedEducation"
        >
          <v-card>
            <v-card-title>
              <span class="headline">Боловсрол</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field v-model="editedEducation.name" label="Нэр" />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field
                      v-model="editedEducation.startDate"
                      label="Орсон огноо"
                    />
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field
                      v-model="editedEducation.endDate"
                      label="Төгссөн огноо"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field
                      v-model="editedEducation.certifcateNumber"
                      label="Гэрчилгээний дугаар"
                    />
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-select
                      v-model="editedEducation.educationDegree"
                      :items="educationDegrees"
                      label="Боловсролын зэрэг"
                    ></v-select>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-btn color="secondary" @click="_deleteEducation">
                Устгаx
              </v-btn>
              <v-spacer />
              <v-btn color="blue darken-1" text @click="_closeEducationDialog">
                Цуцлаx
              </v-btn>
              <v-btn color="blue darken-1" text @click="_saveEducationDialog">
                Xадгалаx
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="addJobDialog" max-width="500px" v-if="editedJob">
          <v-card class="py-4">
            <v-card-title>
              <span class="headline font-weight-bold">Ажил мэргэжил</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field v-model="editedJob.name" label="Нэр" />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field
                      v-model="editedJob.startDate"
                      label="Орсон огноо"
                    />
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field
                      v-model="editedJob.endDate"
                      label="Төгссөн огноо"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      v-model="editedJob.jobType"
                      label="Албан тушаал"
                    />
                  </v-col>
                  <!-- <v-col cols="12" sm="6" md="6">
                <v-select
                  v-model="editedJob.educationDegree"
                  :items="educationDegrees"
                  label="Боловсролын зэрэг"
                ></v-select>
              </v-col> -->
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-btn color="secondary" @click="_deleteJob"> Устгаx </v-btn>
              <v-spacer />
              <v-btn color="blue darken-1" text @click="_closeJobDialog">
                Цуцлаx
              </v-btn>
              <v-btn color="blue darken-1" text @click="_saveJob">
                Xадгалаx
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="addLanguageDialog"
          max-width="500px"
          v-if="editedLanguage"
        >
          <v-card class="py-10">
            <v-card-title class="headline"> Гадаад xэл </v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field v-model="editedLanguage.name" label="Нэр" />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    v-model="editedLanguage.startDate"
                    label="Орсон огноо"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    v-model="editedLanguage.endDate"
                    label="Төгссөн огноо"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    v-model="editedLanguage.certifcateNumber"
                    label="Гэрчилгээний дугаар"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-select
                    v-model="editedLanguage.educationDegree"
                    :items="educationDegrees"
                    label="Түвшин"
                  ></v-select>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-btn color="secondary" @click="_deleteLanguage"> Устгаx </v-btn>
              <v-spacer />
              <v-btn color="blue darken-1" text @click="_closeLanguageDialog">
                Цуцлаx
              </v-btn>
              <v-btn color="blue darken-1" text @click="_saveLanguageDialog">
                Xадгалаx
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </material-card>
    </v-container>
    <v-footer padless fixed>
      <section class="container py-4">
        <v-container>
          <v-row
            no-gutters
            justify="space-between"
            style="width: 800px"
            class="mx-auto mt-4"
          >
            <v-btn text color="primary" @click="_back">
              <v-icon left> mdi-chevron-left </v-icon>Буцаx
            </v-btn>
            <v-btn color="primary" min-width="150" @click="save">
              Xадгалаx
            </v-btn>
          </v-row>
        </v-container>
      </section>
    </v-footer>
  </v-app>
</template>

<script>
import { mapState } from "vuex";
import VueQrcode from "vue-qrcode";
import moment from "moment";

const fb = require("../../firebaseConfig.js");
export default {
  name: "UserProfileView",
  data: () => ({
    userData: null,
    educationDegrees: ["Дунд", "Бүрэн дунд", "Баклавар", "Магистр", "Доктор"],
    editedJobIndex: -1,
    editedJob: null,
    addJobDialog: false,
    editedEducationIndex: -1,
    editedEducation: null,
    addEducationDialog: false,

    addLanguageDialog: false,
    editedLanguage: null,
    editedLanguageIndex: -1,

    tab: null,
    educations: null,
    languages: null,
    jobs: null,
  }),
  computed: {
    ...mapState(["userProfile", "currentUser"]),
  },
  components: {
    VueQrcode,
  },
  created() {
    fb.db
      .collection("schools")
      .doc(this.schoolId)
      .collection(this.collectionName)
      .doc(this.userId)
      .onSnapshot((doc) => {
        let user = doc.data();
        user.id = doc.id;
        user.ref = doc.ref;
        this.userData = user;

        fb.db
          .doc(user.ref.path)
          .collection("educations")
          .onSnapshot((querySnapshot) => {
            this.educations = [];
            querySnapshot.forEach((doc) => {
              let eduData = doc.data();
              eduData.id = doc.id;
              eduData.ref = doc.ref;
              this.educations.push(eduData);
            });
          });
        fb.db
          .doc(user.ref.path)
          .collection("jobs")
          .onSnapshot((querySnapshot) => {
            this.jobs = [];
            querySnapshot.forEach((doc) => {
              let eduData = doc.data();
              eduData.id = doc.id;
              eduData.ref = doc.ref;
              this.jobs.push(eduData);
            });
          });
        fb.db
          .doc(user.ref.path)
          .collection("languages")
          .onSnapshot((querySnapshot) => {
            this.languages = [];
            querySnapshot.forEach((doc) => {
              let eduData = doc.data();
              eduData.id = doc.id;
              eduData.ref = doc.ref;
              this.languages.push(eduData);
            });
          });

        if (this.userData.address === undefined) {
          this.userData.address = {};
        }
      });
  },
  methods: {
    _deleteEducation() {
      this.editedEducation.ref.delete();
      this.editedEducationIndex = -1;
      this.addEducationDialog = false;
    },
    _getDate(datee) {
      return new Date(datee.toDate());
    },
    _saveEducationDialog() {
      console.log(this.editedEducation.ref.path);
      this.editedEducation.ref.update(this.editedEducation);
      this.editedEducationIndex - 1;
      this.editedEducation = null;
      this.addEducationDialog = false;
    },
    _closeEducationDialog() {
      this.addEducationDialog = false;
      this.editedEducationIndex - 1;
    },
    _editEducation(educa, index) {
      this.editedEducation = educa;
      this.editedEducationIndex = index;
      this.addEducationDialog = true;
    },
    _addEducation() {
      var newEducation = {
        name: "Ih surguuli",
        startDate: new Date(),
        endDate: new Date(),
        certifcateNumber: 222,
        educationDegrees: 222,
      };
      console.log(this.userData.ref.path);
      this.userData.ref.collection("educations").doc().set(newEducation);
    },
    _back() {
      this.$router.back();
    },
    _trim(str) {
      if (str) return str.trim();
      else if (str == undefined) return null;
      else str;
    },
    save() {
      console.log(this.userData);
      this.userData.ref.update(this.userData);
      this.$router.back();
    },
    _addJob() {
      var newJob = {
        name: "New Job",
        startDate: null,
        endDate: null,
        jobType: null,
        where: null,
      };
      this.userData.ref.collection("jobs").doc().set(newJob);
    },
    _closeJobDialog() {
      this.addJobDialog = false;
      this.editedJobIndex = -1;
    },
    _editJob(job, index) {
      console.log(job, index);
      this.addJobDialog = true;
      this.editedJob = job;
      this.editedJobIndex = index;
    },
    _deleteJob() {
      this.editedJob.ref.delete();
      this.editedJobIndex = -1;
      this.addJobDialog = false;
    },
    _saveJob() {
      fb.usersCollection
        .doc(this.userId)
        .set(this.userData, { merge: true })
        .then(() => {})
        .catch((err) => {});

      this.addJobDialog = false;
      this.editedJobIndex = -1;
    },
    //language
    _addLanguage() {
      var newItem = {
        name: "Ih surguuli",
        startDate: new Date(),
        endDate: new Date(),
        certifcateNumber: 222,
        level: 222,
      };
      this.userData.ref.collection("languages").doc().set(newItem);
    },
    _deleteLanguage() {
      this.editedLanguage.ref.delete();
      this.editedLanguageIndex = -1;
      this.addLanguageDialog = false;
    },
    _saveLanguageDialog() {
      this.editedLanguage.ref.update(this.editedLanguage);
      this.editedLanguageIndex = -1;
      this.editedLanguage = null;
      this.addLanguageDialog = false;
    },

    _editedLanguage(language, index) {
      this.editedLanguage = language;
      this.editedLanguageIndex = index;
      this.addLanguageDialog = true;
    },
    _closeLanguageDialog() {
      this.editedLanguageIndex = -1;
      this.editedLanguage = null;
      this.addEducationDialog = false;
    },
  },
  props: {
    schoolId: {
      type: String,
      required: true,
    },
    collectionName: {
      type: String,
      required: true,
    },
    userId: {
      type: String,
      required: true,
    },
  },
};
</script>
